var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"flex justify-between p-l-2 p-t-8"},[_c('div',{staticClass:"fz13"},[_vm._v("Scrubber")]),_c('b-form-checkbox',{attrs:{"id":"calc_scrubber","checked":_vm.value},on:{"input":(val) => _vm.$emit('input', val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }